import {
  Avatar,
  Box,
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Typography,
} from '@mui/material';
import { AsyncButton, PrescriptionDialogStyle } from 'Components';
import { useIsDesktop } from 'Hooks';
import { useState } from 'react';
import { DialogTitleContent } from './DialogTitleContent';
import { EquipmentList } from './EquipmentList';
import { createOrder } from 'API';
import { IOrderSummaryData } from '../CreateOrderForm';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { BGNewMobile, LeftArrowWhite, PenIcon } from 'Images';

interface ISummaryOrderDialogProps {
  handleClose: () => void;
  isSuccessDialogOpen: () => void;
  open: boolean;
  summaryData: IOrderSummaryData;
  orderPeriod: string;
}

export const SummaryOrderDialog = ({
  handleClose,
  isSuccessDialogOpen,
  open,
  summaryData,
  orderPeriod,
}: ISummaryOrderDialogProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isDesktop = useIsDesktop();
  const orderItems = summaryData.orderItems;
  const dictionary = Dictionary[DICTIONARY.Equipment].orderSummaryDialog;

  const dialogTitleStyle = {
    padding: isDesktop ? '0' : '35px 24px 16px 24px',
    background: isDesktop ? '#fff' : `url(${BGNewMobile}) no-repeat`,
    backgroundSize: isDesktop ? undefined : '100%',
    paddingRight: '24px',
    paddingLeft: '24px',
    height: isDesktop ? '92px' : '135px',
  };

  const dialogContentStyle = {
    padding: isDesktop ? '0 32px !important' : '0 24px',
    backgroundColor: isDesktop ? '#FFF' : 'transparent',
    paddingBottom: isDesktop ? undefined : '180px',
    zIndex: 111,
  };

  const sendOrderHandler = async () => {
    setIsLoading(true);

    if (summaryData.orderItems.length > 0) {
      const result = await createOrder(summaryData);

      if (result) {
        isSuccessDialogOpen();
        setIsLoading(false);
        handleClose();
      } else {
        handleClose();
      }
    }
  };

  return (
    <PrescriptionDialogStyle
      open={open}
      onClose={handleClose}
      labelledby='summary-order-dialog-title'
      describedby='summary-order-dialog-content'
    >
      <Box
        sx={{
          background: dialogTitleStyle.background,
          height: isDesktop ? '90vh' : '100vh',
          backgroundSize: dialogTitleStyle.backgroundSize,
        }}
      >
        <Box sx={dialogTitleStyle} id='summary-order-dialog-title'>
          <DialogTitleContent onClose={handleClose} />
        </Box>
        <DialogContent
          sx={dialogContentStyle}
          id='summary-order-dialog-content'
        >
          <EquipmentList orderItems={orderItems} orderPeriod={orderPeriod} />
          <Divider
            aria-hidden='true'
            sx={{ m: '40px 0 0 0', borderColor: 'primary.shade_200' }}
          />
          {summaryData.note && (
            <>
              <Typography
                sx={{
                  margin: '30px 0 15px 0',
                  fontSize: '18px',
                  fontWeight: 'bold',
                }}
              >
                {dictionary.orderNote}
              </Typography>
              <Typography variant='body6'>{summaryData.note}</Typography>
            </>
          )}
        </DialogContent>
        <DialogActions
          sx={
            isDesktop
              ? {
                  backgroundColor: '#fff',
                  padding: '40px',
                }
              : {
                  justifyContent: 'center',
                  backgroundColor: '#fff',
                  flexDirection: 'row',
                  position: 'fixed',
                  bottom: 0,
                  width: '100%',
                }
          }
        >
          <Button
            sx={{
              display: isLoading ? 'none' : undefined,
              p: isDesktop ? '8px 48px' : '4px 16px',
              width: isDesktop ? '320px' : '50%',
              fontSize: isDesktop ? '18px' : '16px',
              fontWeight: 700,
            }}
            variant='outlined'
            onClick={() => handleClose()}
          >
            {dictionary.editOrder}
          </Button>
          <AsyncButton
            loading={isLoading}
            variant='contained'
            sx={
              isDesktop
                ? {
                    padding: '8px 48px',
                    width: isDesktop ? '320px' : '50%',
                    fontSize: '18px',
                    fontWeight: 600,
                    ml: '32px !important',
                  }
                : {
                    fontSize: '16px',
                    fontWeight: 600,
                    padding: '5px 24px',
                  }
            }
            onClick={sendOrderHandler}
            endIcon={
              <Avatar
                src={LeftArrowWhite}
                alt=''
                sx={{
                  width: '21px',
                  height: '20px',
                }}
              />
            }
          >
            {dictionary.submitOrder}
          </AsyncButton>
        </DialogActions>
      </Box>
    </PrescriptionDialogStyle>
  );
};
